module.exports = __webpack_public_path__ + "img/icon_off.f9ec447.png";